<div class="modal-header">
	<h2 [translate]="'Actions.AddUsers'"></h2>
	<button type="button" data-cy="ModalClose" class="modal-button-close far fa-times" (click)="activeModal.dismiss()"></button>
</div>

<form [formGroup]="form"  autocomplete="off">
	<div class="modal-body">
		<div class="row">
			<div class="col-lg-8">
				<div class="form-group">
					<label class="form-label" for="field-addUserName" translate="UserForm.Email"></label>
					<input class="form-control form-control-alt" formControlName="addUserName"
						[class.is-invalid]="addUserNameField.dirty && addUserNameField.invalid" />
					<form-control-feedback [field]="addUserNameField"/>
				</div>
			</div>
			<div class="form-actions addEmail">
				<button [disabled]="addUserNameField.invalid" type="submit" (click)="addToGuestsList()">
					<i class="fas fa-plus-circle"></i>
				</button>
			</div>
		</div>
		<div class="form-user-list">
			@for (control of guestsList.controls; track control) {
				<ng-container [formGroup]="control">
					<div class="col-lg-8">
						<div class="row">
							<div class="col-7">
								<div class="form-group">
									<input
										class="form-control form-control-alt"
										formControlName="userName"
									/>
								</div>
							</div>
							<div class="col-1">
								<button (click)="removeInvite($index)" class="btn" type="button" data-cy="Delete"><i class="fa fa-trash"></i></button>
							</div>
						</div>
					</div>
				</ng-container>
			}
		</div>
	</div>

	<div class="modal-footer">
		<button class="btn btn-default" type="button" translate="Actions.Cancel" data-cy="Cancel"
			(click)="activeModal.dismiss()"></button>
		<button class="btn btn-primary" type="submit" translate="Actions.Invite" data-cy="Invite" (click)="onSubmit()"
			[disabled]="guestsList.length === 0"></button>
	</div>
</form>
